import { mapSubpageHero } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import { Asset } from '../Asset/Asset'
import Heading from '../Heading/Heading'
import { subpageHero } from './SubpageHero.css'

type SubPageHeroProps = {
  isTopOfPage?: boolean
} & ReturnType<typeof mapSubpageHero>

export const SubpageHero: FC<SubPageHeroProps> = ({
  description,
  headline,
  asset,
  isTopOfPage,
}) => {
  return (
    <div className={subpageHero._}>
      <div className={subpageHero.mainText._}>
        <Heading
          description={description}
          headline={headline}
          level={isTopOfPage ? 1 : 2}
          size={'xxl'}
        />
      </div>
      <div className={subpageHero.asset}>
        <Asset video={asset.video} />
      </div>
    </div>
  )
}
